<script setup lang="ts">
export type Color = 'red' | 'yellow' | 'grey' | 'black' | 'green' | 'white' | 'blue' | 'pink'

defineProps<{ color: Color | undefined }>()
</script>

<template>
  <span :class="[$style.c, color]" />
</template>

<style module>
.c {
  composes: global(_br99);
  composes: global(_noflex);
  composes: global(_flexline);

  height: 7px;
  width: 7px;
}
.c:global(.red) {
  background: hsl(0, 80%, 50%);
}
.c:global(.yellow) {
  background: hsl(43deg 100% 50%);
  box-shadow: 0 0 0 1px hsl(43deg 100% 50% / 30%);
}
.c:global(.grey) {
  background: var(--black-4);
}
.c:global(.black) {
  background: var(--black);
}
.c:global(.green) {
  background: rgb(203, 232, 161);
}
.c:global(.white) {
  background: #fafafa;
}
.c:global(.blue) {
  background: rgb(100, 100, 255);
}
.c:global(.pink) {
  background: pink;
}
</style>
